
<div>
    <div class="cancel_details">
        <!-- <div class="dlt">
            <div>
                <img src="../../../../assets/image/mdi_alert.svg" alt="">
            </div>
            <div>
                <span class="Dlt_title">Save Details</span>
            </div>
        </div> -->
        <p class="dlt_mge">Save Details ?</p>
        <div class="selected_list">
            <button class="cancel" (click)="cancel()">Close</button>
            <button class="delete" (click)="save()">Ok</button>
        </div>
    </div>
</div>